
  import {Component, Vue, Watch} from "vue-property-decorator";
  import PagedTableView from "@/components/PagedTableView/index.vue";
  import api from '@/api/index';
  import {IncomeSupplementCategory, IncomeSupplementDto} from "@/api/appService";
  import {SelectListItem} from "@/core/common-type-definitions";
  import ExportButton from "@/components/ExportButton/index.vue";
  import ImportExcel from "@/components/ImportExcel/index.vue";
  import EditIncomeSupplement from "@/views/pays/components/edit-incomeSupplement.vue";
  import UploadTemplate from "@/components/UploadTemplate/index.vue";

  interface IncomeSupplementQueryForm{
    category?:IncomeSupplementCategory;
    year?:number;
    month?:number;
    displayName?:string;

  }

  @Component({
    components: {UploadTemplate, EditIncomeSupplement, ImportExcel, ExportButton, PagedTableView},
    filters:{
      formatCategory(row:IncomeSupplementDto){
        if(row.category === IncomeSupplementCategory.Activity){
          return '活动收入'
        } else {
          return `${row.displayName}`
        }
      }
    }
  })
  export default class IncomeSupplement extends Vue{

    queryForm:IncomeSupplementQueryForm = {
      category : undefined,
      displayName:'',
      month:undefined,
      year:undefined
    };

    @Watch('queryForm.category')
    onCategoryChange(newCategory:IncomeSupplementCategory){
      if(newCategory === IncomeSupplementCategory.Activity){
        this.queryForm.displayName = '';
      }
    }

    get allCategories() :SelectListItem<IncomeSupplementCategory>[] {
      return [
        {
          label:'活动收入',
          value:IncomeSupplementCategory.Activity
        },
        {
          label:'会员卡',
          value:IncomeSupplementCategory.Card
        },
      ]
    }

    get isCardCategory(){
      return this.queryForm.category === IncomeSupplementCategory.Card;
    }

    fetchData(params:any){
      return api.incomeSupplement.getAll(params);
    }

    handleDelete(row:IncomeSupplementDto){
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.incomeSupplement.delete ({ id: row.id }).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    }

    handleCreate(){
      (this.$refs.editIncomeSupplement as any).dataId = 0;
      (this.$refs.editIncomeSupplement as any).show = true;
    }

    handleEdit(row:IncomeSupplementDto){
      (this.$refs.editIncomeSupplement as any).dataId = row.id;
      (this.$refs.editIncomeSupplement as any).show = true;
    }
  }
